enum TipoConteoAuditoria {
    Conteo = 1,
    Reconteo = 2,
}

export default TipoConteoAuditoria;